export default __webpack_public_path__ + "assets/models/879d71ac6b7aef0843fa6baac1dcf29d.glb";